<template>
  <select ref="root" class="components-wrapper__select2">
    <slot></slot>
  </select>
</template>

<style src="select2/dist/css/select2.css"></style>

<script setup>
  import $ from "jquery";
  import { onMounted, onUnmounted, ref } from 'vue';
  import "wrapper/select2";
 
  const root = ref<HTMLElement | null>(null);

  onMounted(()=>{
    if (root.value) 
     $(root.value).select2();
  })

  onUnmounted(() => {
    if (root.value)
      $(root.value).off().select2("destroy");
  })
</script>
